import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-white" data-id="element-44" data-mp="1ntzxx8rhxr1b">
      <div className="mx-auto max-w-letter px-4 py-7 sm:px-6 sm:py-8" data-id="element-45" data-mp="1nwmdnvojjcum">
        <h2 id="faq" className="text-center font-display text-xl uppercase leading-[1.1] tracking-tight text-brand-dark sm:text-3xl" data-id="element-46" data-mp="2bkvvkmimvggh">
          Preguntas frecuentes
        </h2>

        <div className="mt-4 divide-y divide-line overflow-hidden rounded-lg border border-line" data-id="element-47" data-mp="21uaqcg8gfdol">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="bg-white" data-id="element-48" data-mp="2uhwzs54d5cjd" data-mpi={i}>
                <h3 data-id="element-49" data-mp="2za6o5gpty4jj">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className={`flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left transition-colors duration-150 ease-soft ${isOpen ? 'bg-mist' : 'hover:bg-mist'}`} data-id="element-50" data-mp="2zaq6uznb0wym">
                    <span className="text-[0.82rem] font-bold leading-snug text-brand-dark sm:text-sm" data-id="element-51" data-mp="2fcz31xt07siy">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={17} strokeWidth={3} className={`flex-shrink-0 text-brand transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-52" data-mp="2ah063ltm126x" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-53" data-mp="p3p487z24bm5">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-54" data-mp="2p5ex2h461ts4">
                      <p className="px-3.5 pb-2.5 pt-1 text-[0.8rem] font-medium leading-snug text-ink-muted sm:text-sm" data-id="element-55" data-mp="38269q7p7dan7">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}